<script setup lang="ts">
  import { useOnline } from '@vueuse/core'
  import { WifiOff } from 'lucide-vue-next'
  import { RouterView } from 'vue-router'
  import { Toaster } from '@/components/ui/sonner'
  import AppPwaUpdatePrompt from './components/app-pwa-update-prompt.vue'

  const isOnline = useOnline()
</script>

<template>
  <div
    v-if="!isOnline"
    class="bg-amber-600 text-white text-xs font-medium py-1.5 px-4 text-center sticky top-0 z-[100] shadow-sm flex items-center justify-center gap-2 transition-all">
    <wifi-off class="size-3.5 shrink-0" />
    <span>Koneksi internet terputus. Beberapa data atau fitur mungkin tidak termuat sempurna.</span>
  </div>
  <router-view />
  <app-pwa-update-prompt />
  <toaster
    position="top-center"
    rich-colors
    close-button />
</template>

<style lang="postcss" scoped>
</style>
